import { DeviceTypes } from '../../../constants/DeviceModels';

/**
 * Truck controller
 *
 * @param rootStore
 * @param turnOn
 */
export const truckSwitch = (rootStore, turnOn = true) => {
  const { batchStore, devicesStore } = rootStore;
  const truck = devicesStore.devices.find(v => v.deviceTypeName === DeviceTypes.TruckDevice);

  if (truck) {
    batchStore.deviceStatus.set(truck.id, {
      ...batchStore.getDeviceStatusDefault(truck),
      id: truck.id,
      active: turnOn,
    });
  }
};
